import React from 'react';
import getLocal from 'eco-design-reliance/getLocal';
import styles from './index.module.scss';
import { EFLoginIcon1, EFLoginIcon2, EFLoginIcon3 } from '@/components/UI/svg/My';
import { isMembersFestival } from '@/utils/membersFestival';

interface EcoCreditDescriptionProps {
    title: string;
    word1: string;
    word2: string;
    word3: string;
    alternativeWord1?: string;
    className?: string;
}

const EcoCreditDescription: React.FC<EcoCreditDescriptionProps> = ({ title, word1, word2, word3, alternativeWord1, className = '' }) => {
    const { locale = 'us' } = getLocal();
    const mfStatus = isMembersFestival(locale);

    const displayWord1 = mfStatus === 0 && alternativeWord1 ? alternativeWord1 : word1;

    return (
        <div className={`${styles.ecocreditDesc} ${className}`}>
            <div className="ecocreditDescTitle" dangerouslySetInnerHTML={{ __html: title }} />
            <div className="ecocreditContent">
                <div className="ecocreditContentItem">
                    <div className="ecocreditContentItemIcon">
                        <EFLoginIcon1 />
                    </div>
                    <div className="ecocreditContentItemText">{displayWord1}</div>
                </div>
                <div className="ecocreditContentItem">
                    <div className="ecocreditContentItemIcon">
                        <EFLoginIcon2 />
                    </div>
                    <div className="ecocreditContentItemText">{word2}</div>
                </div>
                <div className="ecocreditContentItem">
                    <div className="ecocreditContentItemIcon">
                        <EFLoginIcon3 />
                    </div>
                    <div className="ecocreditContentItemText">{word3}</div>
                </div>
            </div>
        </div>
    );
};

export default EcoCreditDescription;
